<template>
    <div class="content-wrapper">
        <div class="main">
            <!-- <images-section></images-section> -->
            <div class="container">
                <template v-if="this.loadingVideos">
                    Loading...
                </template>
                <template v-else>
                    <div id="player"></div>
                    <!-- <videoCardsSection :items="videosLists" /> -->
                    <div role="alert" class="alert">
                        <div class="container">
                            Live Global Prayer
                            <a class=" btn btn-primary" :href="constTxts.golbal_prayer_link_path" target="_blank">
                                Join
                            </a>
                        </div>
                    </div>
                    <div v-if="false" role="alert" class="alert">
                        <div class="container">
                            “The Return” - National Day of Prayer & Repentance, September 26, 4pm-12midnight IST
                                <a class=" btn btn-primary"
                                href="https://thereturn.org/live-stream/" target="_blank">
                                    Join
                                </a>
                        </div>
                    </div>

                    <h2 class="title">Streams</h2>
                    <div class="row">
                        <template v-for="(item, index) in streams">
                            <div class="col-md-6 col-lg-3">
                            <streamCard :itemIndex="index" :item="item" />
                            </div>
                        </template>
                    </div>
                    <h2 class="title">Videos</h2>
                    <div v-for="(item, index) in this.tracks">
                        <videoCardsSection :trackIndex="item.title" :track="item" />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import ImagesSection from '../../pages/components/ImagesSection'
  import videoCardsSection from '../components/videoCardsSection'
  import streamCard from '../components/streamCard'

  import { mapGetters, mapActions } from 'vuex'
  import VueScrollTo from 'vue-scrollto';
  import {texts} from '@/constants/texts'

  export default {
    name: "home",
    bodyClass: 'index-page',
    components: {
      ImagesSection,
      videoCardsSection,
      streamCard,
    },
    data: function () {
        return {
            player: false,
            playerLoaded: false,
        }
    },
    computed: {
        ...mapGetters(['videosLists', 'activeStream', 'currentVideo', 'currentStream', 'streams', 'doneInit', 'loadingVideos']),
        tracks() {
            let tracks = Object.values(this.videosLists).sort(function(a, b) {
                let textA = a.title.toUpperCase();
                let textB = b.title.toUpperCase();
                if (a.title == 'Recently Live') return -1;
                if (b.title == 'Recently Live') return 1;
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            return tracks
        },
        constTxts() { return texts },
        startPlayer: function() {
            if (!this.doneInit) {
                console.log('Waiting....')
            } else {
                console.log('Done Waiting....')
                document.getElementById('player').innerHTML = "";
                this.player = new RMP({
                    'id': 'player',
                    'responsive': true,
                    'autoplay': true,
                    //'width': 854,
                    //'height': 480,
                    'options': {
                        //'account_id': 'AZMLnM',
                        'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                        'event_id': this.activeStream.id
                    }
                });
                //console.log(this.player)

            }

        },
    },
    async mounted() {
        //await this.init();
        // Make network request if the data is empty
        //if (Object.keys(this.videosLists).length === 0) {
        //console.log(this.activeStream)
        //this.initPlayer()
        //console.log('start init')
        await this.getAllVideos()
        //console.log('end init')
        if (!this.activeStream) {
            //this.isLoading = true;
            //await this.init();
            /*Promise.all([
                this.$store.dispatch('autoLogin'),
                this.$store.dispatch('getVideos'),
                this.$store.dispatch('getStream')
            ]).finally(() => {
                // using "finally" so even if there are errors, it stops "loading"
                this.isLoading = false
                this.initPlayer()
            })*/
            //console.log(this.activeStream)
            //this.isLoading = false;
            //this.initPlayer()
        } else {
            //this.isLoading = false;
            //this.initPlayer()
        }

    },
    methods: {
        //...mapActions(['init']),
        ...mapActions(['getAllVideos']),
        async initPlayer() {

            //console.log('initPlayer')
            this.$loadScript("//player.clevercast.com/js/api.js")
            .then((data) => {
                //var player = new RMP({
                document.getElementById('player').innerHTML = "";
                if (this.activeStream !== undefined) {
                    this.player = new RMP({
                        'id': 'player',
                        'responsive': true,
                        'autoplay': true,
                        //'width': 854,
                        //'height': 480,
                        'options': {
                            //'account_id': 'AZMLnM',
                            //'account_id': '28Mm4v',
                            'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                            'event_id': this.activeStream.id
                            //'item_id': process.env.VUE_APP_CLEVERCAST_DEFAULT_ITEM_ID,
                        }
                    });
                } else {
                    this.player = new RMP({
                        'id': 'player',
                        'responsive': true,
                        'autoplay': true,
                        'options': {
                            'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                            'item_id': this.tracks[0].videos[0].id,
                        }
                    });
                }
                this.playerLoaded = true
            })
            .catch(() => {
                // Failed to fetch script
            });
        },
    },
    watch: {
        currentVideo: function(newVideo) {
            /*document.getElementById('player').innerHTML = "";
            var player = new RMP({
                'id': 'player',
                'width': 854,
                'height': 480,
                'options': {
                    'account_id': 'AZMLnM',
                    'item_id': newVideo.id
                }
            });*/
            this.player.load({
                //'account_id': 'AZMLnM',
                'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                'item_id': newVideo.id,
            })
            //this.player.play({})
            this.$scrollTo('#player', 500, {offset: -60})
        },
        activeStream: function(videoStreamItem) {
            //console.log(videoStreamItem)
            //this.initPlayer()
        },
        currentStream: function(newStream) {
            if (!this.playerLoaded) {
                this.player = new RMP({
                    'id': 'player',
                    'width': 854,
                    'height': 480,
                    'options': {
                        //'account_id': 'AZMLnM',
                        'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                        'event_id': newStream.id
                    }
                });
            } else {
                this.player.load({
                    //'account_id': 'AZMLnM',
                    'account_id': process.env.VUE_APP_CLEVERCAST_ACCOUNT_ID,
                    'event_id': newStream.id
                })
            }
        },
        loadingVideos: function(status) {
            if (status === false) {
                if (this.playerLoaded === false) {
                    this.initPlayer()
                }
            }
        }

    },
  };
</script>

<style>
.alert {
    margin-top: 2em;
    padding: 0 !important;
    background-color: black;
    text-align: center;
    font-size: 1.4em;
}
.alert .btn {
    margin-left: 1em;
}
.card-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2em;
}
.col-md-6 {
    margin-bottom: 2em;
}
.card {
    height: 100%;
}
.card .card-image {
    height: 50%;
    overflow: hidden;
}
.card .card-image img {
    /* height: 100%; */
    height: 100%;
    object-fit: cover;
    width: 100%;
    vertical-align: baseline;
}
</style>
